import { render, staticRenderFns } from "./DirCharts.vue?vue&type=template&id=90dd8158&scoped=true&"
import script from "./DirCharts.vue?vue&type=script&lang=js&"
export * from "./DirCharts.vue?vue&type=script&lang=js&"
import style0 from "./DirCharts.vue?vue&type=style&index=0&id=90dd8158&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dd8158",
  null
  
)

export default component.exports